import React from 'react';
import { useSelector } from 'react-redux';
import { Pane } from 'evergreen-ui';
import { filteredStationsIdsSelector } from 'Features/Filters/Stations';
import StationsFilterFull from 'Features/Filters/StationFilterFull';
import { StationsFullTable } from './StationsFullTable';

export function StationsPage() {
  // note: айди будут по возрастанию, а значит и отображаться также - не знаю так надо или нет
  const filteredStationsIds = useSelector(filteredStationsIdsSelector);

  return (
    <Pane
      display="flex"
      flexDirection="column"
      overflowY="hidden"
    >
      <StationsFilterFull />
      <StationsFullTable flexGrow={1} stationsIds={filteredStationsIds} />
    </Pane>
  );
}
export default StationsPage;
